<!-- Button -->
<!-- <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: activeLang}"></ng-container> -->
<!-- <button id="langCmp_langBtn"
mat-flat-button class="bg-hover bg-white border border-solid border-[--gyser] dark:bg-transparent w-[200px] flex flex-row-reverse justify-between"
[matMenuTriggerFor]="languages">
{{activeLang?.language}}
<mat-icon class="min-h-[20px]" svgIcon="heroicons_outline:chevron-down"></mat-icon>
</button> -->

<!-- <mat-menu
[xPosition]="'before'"
#languages="matMenu">
<ng-container *ngFor="let lang of availableLangsNew; let i=index; trackBy: trackByFn">
  <button
    mat-menu-item id="langCmp_item_{{i}}"
    (click)="setActiveLang(lang)">
    <span class="flex items-center"> -->
      <!-- <span class="fi" [ngClass]="'fi-' + lang.flagLang"></span> -->
      <!-- <span>{{lang.language}}</span>
    </span>
  </button>
</ng-container>
</mat-menu> -->

<div>
  <mat-form-field class="pt-[20px] h-[80px] center-text">
    <mat-select [(ngModel)]="activeLang" (selectionChange)="setActiveLang($event.value)" panelClass="example-long-panel">

      <mat-select-trigger class="flex items-center">
        <mat-icon class="mr-2">language</mat-icon>
        {{ activeLang.locale | uppercase}}
      </mat-select-trigger>

      @for (lang of availableLangsNew; track lang; let i = $index) {
        <mat-option [value]="lang">
          {{ lang.language }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>


<!-- Flag image template -->
<!-- [src]="'assets/images/flags/' + flagCodes[lang].toUpperCase() + '.svg'" -->
<!-- <ng-template
let-lang
#flagImage>
<span class="height-width relative w-6 shadow rounded-sm overflow-hidden">
  <span class="absolute inset-0"></span>
  <span class="fi flag-class" [ngClass]="'fi-' + activeLang?.flagLang"></span>
</span>
</ng-template> -->
